import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sek.icon",
  "use": "sek.icon-usage",
  "viewBox": "0 0 2706 1792",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 2706 1792\" id=\"sek.icon\">\n    <path fill-rule=\"evenodd\" d=\"M1453.059 1792h-388.28L748.68 1346.489l-92.092 102.044V1792H338V0h318.588v1030.4l378.324-433.067h378.323l-462.948 520.178L1453.059 1792zm477.882-973.156c82.136-151.822 214.052-226.488 438.059-241.422v378.311c-74.67-19.91-146.85-19.91-219.03 0-114.492 32.356-219.029 141.867-219.029 336V1792h-318.588V597.333h318.588v221.511z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol